export const progressbar = {
  root: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    height: "calc({typography.body.text.semibold.font.size} * 2)",
  },
  value: {
    background: "{highlight.default}",
  },
  label: {
    color: "{color.white}",
    fontSize: "{typography.body.text.semibold.font.size}",
    fontWeight: "{typography.body.text.semibold.font.weight}",
  },
};
